
import ServicesNavbar from './components/ServicesNavbar';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import ProcessSteps from './components/ProcessSteps';
import Pricing from './components/Pricing';
import ServicesCTA from './components/ServicesCTA';
import ServicesFooter from './components/ServicesFooter';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <ServicesNavbar />
      <ServicesHero />
      <ServicesList />
      <ProcessSteps />
      <Pricing />
      <ServicesCTA />
      <ServicesFooter />
    </div>
  );
}
